/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useMemo, useRef, useCallback, memo } from "react";

// antd:
import { AutoComplete, Input } from "antd";

// import type * as CSS from "csstype";

interface Option {
  value:string;
  label:string;
  disabled?:boolean;
  options?:Option
}

const KEY_BACKSPACE = "Backspace";
const KEY_F2 = "F2";
const KEY_ENTER = "Enter";
const KEY_TAB = "Tab";

// Redux-hooks:
// import { useAppSelector, useAppDispatch } from "../../libs/redux-hooks.ts";

// Reducers:
// import { getDict, getTheme, getLng } from "../../libs/reducer.ts";

const { rz } = window;

type componentProps = {
  params:{
    value:string | string[] | {[key:string]:any}[] | undefined,
    values?:(itms:string[] | {[key:string]:any}[] | undefined) => Promise<{value:string, label:string, disabled?:boolean} | {value:string, label:string, disabled?:boolean}>,
    onValueChange:(newValue:string | string[] | {[key:string]:any}[] | undefined) => void,
    specialCellEditorOnChange?:(newValue:string | string[] | {[key:string]:any}[] | undefined) => void,
    stopEditing?:() => void, saveToDatabase?:boolean, node:any,
    column:{[key:string]:any},
    appkey?:string,
    aggridkey?:string,
    gridRef?:any,
    fullPath?:string,
    lng?:string,
    user?:{login:string, groups:string[], name?:string},
    lookupField?:string,
    eventKey?:string,
    rowIndex?:number | string,
    items?:Option[],
    options?:Option[],
    allowClear?:boolean,
    defaultOpen?:boolean,
    autoFocus?:boolean,
    placeholder?:string,
    disabled?:boolean,
    tooltip?:string,
    textarea?:boolean,
    rows?:number,
    cols?:number,
    safe?:boolean
  }
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

// eslint-disable-next-line react/display-name
export default memo((params:componentProps) => {
  // console.log(params);
  const {
    appkey, aggridkey, gridRef, fullPath, lng, user, lookupField, value, values, onValueChange, eventKey, disabled,
    rowIndex, column, options, items, allowClear, defaultOpen, autoFocus, tooltip, placeholder, textarea, rows, cols,
    specialCellEditorOnChange, stopEditing, node, saveToDatabase, safe
  } = params;

  const refInput = useRef(null);

  const initValues = useMemo(() => {
    if (value && rz.isString(value)) { return value }
    if (rz.isObject(value)) {
      if (lookupField) { return value[lookupField] }
      return (value.value || value._id);
    }
    if (rz.isArray(value)) {
      return value.map((vv) => {
        if (vv && rz.isString(vv)) { return vv }
        if (rz.isObject(vv)) {
          if (lookupField) { return vv[lookupField] }
          return (vv.value || vv._id);
        }
        return undefined;
      }).filter((vv) => (vv));
    }
    return undefined;
  }, [value, lookupField]);

  const [myValue, setMyValue] = useState(initValues);

  const [loading, setLoading] = useState(true);
  const [selectItems, setItems] = useState([]);

  useEffect(() => {
    if (!values) {
      const userItems = (options || items || []);
      const checkedItems = userItems.map((vv) => {
        if (rz.isString(vv)) { return {_id: vv, value: vv, title: vv, label: vv} }
        if (rz.isObject(vv)) {
          const ttl = rz.strFromSelectedLng({lng: lng || "en", en: vv.title_en, ru: vv.title_ru, tr: vv.title_tr, def: vv[lookupField] || vv.title || vv.label});
          return {_id: vv._id, value: vv[lookupField] || vv.value || vv._id, title: ttl, label: ttl}
        }
        return null;
      }).filter((vv) => (vv && vv.value));

      setItems(checkedItems); setLoading(false);
      return;
    }
    if (rz.isArray(values)) {
      const vls = values.map((vv) => {
        if (rz.isString(vv)) { return {_id: vv, value: vv, title: vv, label: vv} }
        if (rz.isObject(vv)) {
          const ttl = rz.strFromSelectedLng({lng: lng || "en", en: vv.title_en, ru: vv.title_ru, tr: vv.title_tr, def: vv[lookupField] || vv.title || vv.label});
          return {_id: vv._id, value: vv[lookupField] || vv.value || vv._id, title: ttl, label: ttl}
        }
        return undefined;
      }).filter((vv) => (!rz.isUndefinedOrNull(vv)));
      setItems(vls); setLoading(false);
    }
    else if (appkey && rz.isString(values) && window[appkey] && window[appkey][values]) {
      if (rz.isPromise(window[appkey][values])) {
        window[appkey][values]({appkey, aggridkey, lookupField, fullPath, lng, column, rowIndex, initValues, safe}).then((rowsAns) => {
          if (!rowsAns || !rz.isArray(rowsAns)) { setItems([]) } else { setItems(rowsAns) }
          setLoading(false);
        }).catch((err) => { console.log(err) });
      }
      else if (rz.isFunction(window[appkey][values])) {
        const rowsAns = window[appkey][values]({appkey, aggridkey, lookupField, fullPath, lng, column, rowIndex, initValues, safe});
        if (!rowsAns || !rz.isArray(rowsAns)) { setItems([]) } else { setItems(rowsAns) }
        setLoading(false);
      }
    }
    else if (rz.isPromise(values)) {
      values({appkey, aggridkey, lookupField, fullPath, lng, column, rowIndex, initValues, safe}).then((rowsAns) => {
        if (!rowsAns || !rz.isArray(rowsAns)) { setItems([]) } else { setItems(rowsAns) }
        setLoading(false);
      }).catch((err) => { console.log(err) });
    }
    else if (rz.isFunction(values)) {
      const rowsAns = values({appkey, aggridkey, lookupField, fullPath, lng, column, rowIndex, initValues, safe});
      if (!rowsAns || !rz.isArray(rowsAns)) { setItems([]) } else { setItems(rowsAns) }
      setLoading(false);
    }
  }, [aggridkey, appkey, column, fullPath, initValues, items, lng, lookupField, options, rowIndex, values, safe]);

  const onBlur = useCallback((event:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    // console.log("onBlur()", {val: event.target.value, specialCellEditorOnChange});
    setMyValue(event.target.value);
    if (specialCellEditorOnChange) { specialCellEditorOnChange({appkey, aggridkey, gridRef, fullPath, controlType: "autocomplete", lookupField, value: event.target.value, node, saveToDatabase, items: selectItems, column, rowIndex, lng, user, safe}) }
    else { onValueChange(event.target.value) }
    stopEditing();
  }, [specialCellEditorOnChange, onValueChange, stopEditing, appkey, aggridkey, gridRef, fullPath, lookupField, node, saveToDatabase, selectItems, column, rowIndex, lng, user, safe]);

  const onPressEnter = useCallback((event:React.KeyboardEvent<HTMLInputElement | HTMLFormElement | HTMLTextAreaElement>) => {
    // @ts-ignore
    console.log("onPressEnter()", {value: event.target.value, column, textarea, event});
    if (textarea && event.shiftKey) { return }
    // @ts-ignore
    if (specialCellEditorOnChange) { specialCellEditorOnChange({appkey, aggridkey, gridRef, fullPath, controlType: "autocomplete", lookupField, value: event.target.value, node, saveToDatabase, items: selectItems, column, rowIndex, lng, user, safe}) }
    // @ts-ignore
    else { onValueChange(event.target.value) }
    stopEditing();
  }, [textarea, specialCellEditorOnChange, stopEditing, appkey, aggridkey, gridRef, fullPath, lookupField, node, saveToDatabase, selectItems, column, rowIndex, lng, user, onValueChange, safe]);

  const onClear = useCallback((prms) => {
    // console.log("onClear()");
    if (specialCellEditorOnChange) { specialCellEditorOnChange({appkey, aggridkey, gridRef, fullPath, controlType: "autocomplete", lookupField, value: "", node, saveToDatabase, items: selectItems, column, rowIndex, lng, user, safe}) }
    // @ts-ignore
    else { onValueChange("") }
    stopEditing();
  }, [specialCellEditorOnChange, onValueChange, stopEditing, appkey, aggridkey, gridRef, fullPath, lookupField, node, saveToDatabase, selectItems, column, rowIndex, lng, user, safe]);

  const acOnSearch = useCallback((val:string) => {
    setMyValue(val);
  }, []);

  const acOnSelect = useCallback((val:string) => {
    // console.log("acOnSelect()", {val});
    setMyValue(val);
    if (specialCellEditorOnChange) { specialCellEditorOnChange({appkey, aggridkey, gridRef, fullPath, controlType: "autocomplete", lookupField, value: val, node, saveToDatabase, items: selectItems, column, rowIndex, lng, user, safe}) }
    else { onValueChange(val) }
    stopEditing();
  }, [specialCellEditorOnChange, onValueChange, stopEditing, appkey, aggridkey, gridRef, fullPath, lookupField, node, saveToDatabase, selectItems, column, rowIndex, lng, user, safe]);

  const handleKeyDown = useCallback((event) => {
    const {key, code, ctrlKey, shiftKey} = event;
    console.log({key, code, ctrlKey, shiftKey});
  }, []);

  useEffect(() => {
    let startValue, highlightAllOnFocus = true;
    // if backspace or delete pressed, we clear the cell
    if (eventKey === KEY_BACKSPACE) { startValue = "" }
    // if a letter was pressed, we start with the letter
    else if (eventKey && eventKey.length === 1) { startValue = eventKey; highlightAllOnFocus = false }
    else {
      startValue = value; // otherwise we start with the current value
      if (eventKey === KEY_F2) { highlightAllOnFocus = false }
    }
    if (rz.isUndefinedOrNull(startValue)) { startValue = "" }

    setMyValue(startValue);

    // get ref from React component
    const eInput = refInput?.current;
    // @ts-ignore
    if (eInput) { eInput.focus() }
  }, [aggridkey, appkey, column, eventKey, fullPath, lng, lookupField, onValueChange, rowIndex, selectItems, user, value, safe]);

  const filterOption = useCallback((inputValue:string, option:any) => {
    let item = (rz.isObject(option) ? (option.title || option.label || option.value || option.key) : (option || ""));
    if (rz.isObject(item) && item.props && item.props.children && item.props.children.length) { // If we have a ReactElement inside 'option'
      const chlds = item.props.children.filter((ch) => (ch && ch.props && ch.props.children && rz.isString(ch.props.children))).map((ch) => (ch.props.children));
      if (chlds && chlds.length) { item = chlds[0] }
    }
    return rz.strCompare(item, inputValue, ".caseNoSensitive.toLowerCase.trim.substring");
  }, []);

  // Debug:
  // console.log({ appkey, value, items, selectItems, specialCellEditorOnChange, eventKey, rowIndex, column, lookupField, safe });

  return (
    <AutoComplete
      options={selectItems}
      value={myValue}
      // defaultValue={myValue}
      onSelect={acOnSelect} onSearch={acOnSearch}
      filterOption={filterOption}
      // @ts-ignore
      onClear={onClear}
      defaultOpen={rz.isUndefinedOrNull(defaultOpen) ? true : defaultOpen}
      autoFocus={rz.isUndefinedOrNull(autoFocus) ? true : autoFocus}
      maxTagCount={100}
      ref={refInput}
      className={"rz-width-1-1 rz-child-width-1-1"}
    >
      {textarea
        ? <Input.TextArea
            value={myValue}
            // defaultValue={myValue}
            placeholder={placeholder}
            uk-tooltip={tooltip}
            allowClear={rz.isUndefinedOrNull(allowClear) ? true : allowClear}
            variant={"outlined"}
            onPressEnter={onPressEnter} onBlur={onBlur}
            // onKeyDown={handleKeyDown}
            disabled={disabled}
            className={"rz-width-1-1"}
            rows={!rows ? undefined : Number(rows)}
            cols={!cols ? undefined : Number(cols)}
          />
        : <Input
            value={myValue}
            // defaultValue={myValue}
            placeholder={placeholder}
            uk-tooltip={tooltip}
            allowClear={rz.isUndefinedOrNull(allowClear) ? true : allowClear}
            variant={"outlined"}
            onPressEnter={onPressEnter} onBlur={onBlur}
            // onKeyDown={handleKeyDown}
            width={"100%"}
            disabled={disabled}
            className={"rz-width-1-1"}
          />
      }
    </AutoComplete>
  );
});
/* eslint-enable @typescript-eslint/no-unused-vars */
